const SIGN_IN_CSNDIDATE = "/auth/signin_user";
const SIGN_UP_CSNDIDATE = "/auth/signup";

export const candidate = { SIGN_UP_CSNDIDATE, SIGN_IN_CSNDIDATE };
